import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', component: require(page+'home.vue').default },
      { path: '/como-funciona', component: require(page+'how/index.vue').default, meta:{title:"Cómo funciona"}},
      { path: '/preguntas-frecuentes', component: require(page+'faqs/index.vue').default, meta:{title:"Preguntas frecuentes"}},
      { path: '/servicios', component: require(page+'services/index.vue').default, meta:{title:"Servicios"}},
      { path: '/sobre-cae', component: require(page+'about-us/index.vue').default, meta:{title:"Sobre CAE"}},
      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"}},

      { path: '/reglamento-de-mediacion-del-cae', component: require(page+'text-pages/mediacion.vue').default, meta:{title:"Reglamento de mediación del CAE"}},
      { path: '/reglamento-de-arbitraje-expedito-y-de-baja-cuantia', component: require(page+'text-pages/arbitraje.vue').default, meta:{title:"Reglamento de arbitraje expedito y de baja cuantía"}},
      { path: '/arancel-de-honorarios-de-arbitraje-del-cae', component: require(page+'text-pages/arancel.vue').default, meta:{title:"Arancel de honorarios de arbitraje del CAE"}},

      { path: '/comunicados', component: require(page+'blog/index.vue').default, meta:{title:"Comunicados"}},
      { path: '/comunicados/:id', component: require(page+'blog/detail.vue').default, meta:{title:"Comunicado"}},

      { path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"}},
      { path: '/registrarse', component: require(page+'user-access/register.vue').default, meta:{title:"Registrarse"}},
      { path: '/afiliacion', component: require(page+'user-access/join.vue').default, meta:{title:"Afíliate al CAE"}},
      { path: '/solicitud-proceso/:step?', component: require(page+'usuario-cuenta/solicitud-arbitraje.vue').default, meta:{title:"Solicitud de arbitraje"}},

      { path: '/casos', component: require(page+'cases/index.vue').default, meta:{title:"Casos"}},
      { path: '/casos/:id', component: require(page+'cases/detail.vue').default, meta:{title:"Caso"}},

      { path: '/calculadora', component: require(page+'calculadora/index.vue').default, meta:{title:"Calculadora"}},

      { path: '/mensajes', component: require(page+'messages/index.vue').default, meta:{title:"Mensajes"},
        children: [
          {
            path: ':id',
            component: require(page+'messages/detail.vue').default,
            meta:{ title: 'Mensajes del caso' }
          },
        ]
      },

      { path: '/usuario', component: require(page+'usuario-cuenta/index.vue').default, meta:{ title: 'Mi datos' },
  			children: [
  			{
  				path: '/',
  				component: require(page+'usuario-cuenta/mis-datos.vue').default,
  				meta:{ title: 'Mis datos' }
  			},
  			{
  				path: 'contrasena',
  				component: require(page+'usuario-cuenta/contrasena.vue').default,
  				meta:{ title: 'Cambiar contraseña' }
  			},
        // {
        //   path: 'historial-compras',
        //   component: require(page+'usuario-cuenta/historial-compras.vue').default,
        //   meta:{ title: 'Mis pedidos' }
        // },
  	  	]
  		}

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "CAE | Centro de arbitraje empresarial", filter: (title)=>{ return title+" - CAE | Centro de arbitraje empresarial"; } }
);

// export {routes};
export default MyRouter;
